import { render, staticRenderFns } from "./WidgetFileViewer.vue?vue&type=template&id=0c34bf30&scoped=true&"
import script from "./WidgetFileViewer.vue?vue&type=script&lang=js&"
export * from "./WidgetFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFileViewer.vue?vue&type=style&index=0&id=0c34bf30&lang=scss&scoped=true&"
import style1 from "./WidgetFileViewer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c34bf30",
  null
  
)

export default component.exports